const getBackendUrl = function() {
  if(process.env.REACT_APP_API_ENV == 'local') {
      return 'http://localhost:8087/';
  } else if(process.env.REACT_APP_API_ENV == 'dev') {
      return 'https://patientpay-backend-dev.hcck8s-ctc.optum.com/';
  } else if(process.env.REACT_APP_API_ENV == 'qa') {
      return 'https://patientpay-backend-qa.hcck8s-ctc.optum.com/';
  } else if (process.env.REACT_APP_API_ENV == "stagectc") {
    return "https://rxclaim-auth-proxy-client-stg-ctc.optum.com/auth-proxy-module/secure/patientPay/";
  } else if (process.env.REACT_APP_API_ENV == "stageelr") {
    return "https://rxclaim-auth-proxy-client-stg-elr.optum.com/auth-proxy-module/secure/patientPay/";
  } else if (process.env.REACT_APP_API_ENV == "prodctc") {
    return "https://rxclaim-auth-proxy-client-ctc.optum.com/auth-proxy-module/secure/patientPay/";
  } else if (process.env.REACT_APP_API_ENV == "prodelr") {
    return "https://rxclaim-auth-proxy-client-elr.optum.com/auth-proxy-module/secure/patientPay/";
  }
}

export const getPortnousUrl = () => {
if (process.env.REACT_APP_API_ENV == "local") {
  return "https://rxclaim-auth-proxy-client-dev.hcck8s-ctc.optum.com/portunus/abilities";
} else if (process.env.REACT_APP_API_ENV == "dev") {
  return "https://rxclaim-auth-proxy-client-dev.hcck8s-ctc.optum.com/portunus/abilities";
} else if (process.env.REACT_APP_API_ENV == "qa") {
  return "https://rxclaim-auth-proxy-client-ui-qa-ctc.hcck8s-ctc.optum.com/portunus/abilities";
} else if (process.env.REACT_APP_API_ENV == "stagectc") {
  return "https://rxclaim-auth-proxy-client-stg-ctc.optum.com/portunus/abilities";
} else if (process.env.REACT_APP_API_ENV == "stageelr") {
  return "https://rxclaim-auth-proxy-client-stg-elr.optum.com/portunus/abilities";
} else if (process.env.REACT_APP_API_ENV == "prodctc") {
  return "https://rxclaim-auth-proxy-client-ctc.optum.com/portunus/abilities";
} else if (process.env.REACT_APP_API_ENV == "prodelr") {
  return "https://rxclaim-auth-proxy-client-elr.optum.com/portunus/abilities";
}
};

export const getBaseURL = (appName) => {
  if (process.env.REACT_APP_API_ENV === "local") {
    switch (appName) {
      case "ACCUMS":
        return "http://localhost:3115";
      default:
        return null;
    }
  } else if (process.env.REACT_APP_API_ENV === "dev") {
    switch (appName) {
      case "ACCUMS":
        return "https://accumulator-nextgen-dev-ctc.optum.com";
      default:
        return null;
    }
    //return "https://ps.fe.dev.optum.sapient.com/accums-backend-dev/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV === "qa") {
    // return "hhttp://52.252.70.118/accums-backend-dev/portunus/abilities";

    switch (appName) {
      case "ACCUMS":
        return "https://accumulator-nextgen-qa-ctc.optum.com";
      default:
        return null;
    }
  } else if (process.env.REACT_APP_API_ENV === "stagectc") {
    switch (appName) {
      case "ACCUMS":
        return "https://accumulator-nextgen-stg-ctc.optum.com";
      default:
        return null;
    }
    //return "https://ps.fe.dev.optum.sapient.com/accums-backend-dev/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV === "stageelr") {
    // return "hhttp://52.252.70.118/accums-backend-dev/portunus/abilities";

    switch (appName) {
      case "ACCUMS":
        return "https://accumulator-nextgen-stg-elr.optum.com";
      default:
        return null;
    }
  } else if (process.env.REACT_APP_API_ENV === "prodctc") {
    switch (appName) {
      case "ACCUMS":
        return "https://accumulator-nextgen-ctc.optum.com";
      default:
        return null;
    }
    //return "https://ps.fe.dev.optum.sapient.com/accums-backend-dev/portunus/abilities";
  } else if (process.env.REACT_APP_API_ENV === "prodelr") {
    // return "hhttp://52.252.70.118/accums-backend-dev/portunus/abilities";

    switch (appName) {
      case "ACCUMS":
        return "https://accumulator-nextgen-elr.optum.com";
      default:
        return null;
    }
  }
};

export default getBackendUrl;
